import {
  Action,
  ActionType,
  UserListBusinessResponse,
} from "models/userListBusiness/usersListBusiness";
import createReducer from "../../createReducer";

export interface UserListBusinessReducerType {
  loading: boolean;
  error?: string;
  userListBusinessResponse?: UserListBusinessResponse;
}

const defaultState: UserListBusinessReducerType = {
  loading: false,
  error: undefined,
  userListBusinessResponse: undefined,
};

export const userListBusinessReducer =
  createReducer<UserListBusinessReducerType>(defaultState, {
    [ActionType.USER_LIST_BUSINESS](state: UserListBusinessReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.USER_LIST_BUSINESS_ERROR](
      state: UserListBusinessReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        userListBusinessResponse: undefined,
      };
    },

    [ActionType.USER_LIST_BUSINESS_SUCCESS](
      state: UserListBusinessReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        userListBusinessResponse: action.payload,
      };
    },

    [ActionType.USER_LIST_BUSINESS_RESET_DATA](
      state: UserListBusinessReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        userListBusinessResponse: undefined,
      };
    },
  });
